import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import { RejectedBillet } from "../../models/RejectedBillet";

export const useTableData = () => {
	const columnDefs: (ColDef | ColGroupDef)[] = [
		{
			field: "Timestamp",
			headerName: "Timestamp",
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as RejectedBillet)?.Timestamp,
					"HH:mm:ss",
				) || "",
			flex: 1,
			sortable: true,
		},
		{
			field: "CampaignNumber",
			headerName: "Campaign",
			flex: 1,
			sortable: true,
		},
		{
			field: "HeatName",
			headerName: "Heat",
			flex: 1,
			sortable: true,
		},
		{
			field: "SectionName",
			headerName: "Section",
			flex: 1,
			sortable: true,
		},
		{
			field: "ColdLength",
			headerName: "Cold Length",
			flex: 1,
			sortable: true,
		},
		{
			field: "LbsPerFoot",
			headerName: "Lbs/Ft",
			flex: 1,
			sortable: true,
		},
		{
			field: "WeightCold",
			headerName: "Weight (lbs)",
			flex: 1,
			sortable: true,
			valueFormatter: (params) => {
				if (params.value != null) {
					return Number(params.value).toFixed(0);
				}
				return "";
			},
		},
	];

	return { columnDefs };
};
